import {
  // ProductItem,
  EnumStatus,
  IProductSet as OringinalIProductSet,
  IProductSetPriceSettings,
  IProductSetPriceSettingsItems,
} from 'src/types/common/product';
export interface SimpleProductReducer {
  hasModified: boolean;
  dataValid: boolean;
  loaded: boolean;
  status: EnumStatus;
  productInfo?: any;
  //   sku: string;
  //   name: string;
  //   measurementUnit: MeasurementUnit;
  //   remarks: string;
  //   thumbnailImage: Image;
  //   productType: EnumProductType;
  //   stock: number;
  //   defaultSalePrice: number;
  //   defaultCurrency: string;
  //   tags: string[];
  //   status: EnumStatus;
  //   brand: BrandBrand;
  //   barcode: string;
  //   description: string;
  //   codes: ProductCode[];
  //   inventoryQuota: number;
  //   quotaEnabled: boolean;
  //   priceSettings: ProductPriceSetting[];
  //   dimensions: ProductDimensions;
  //   customsInformation: CustomsInformation;
  //   productStorage: ProductStorage;
}

export interface IParams {
  uuid?: string;
}
export enum EnumModifiedType {
  noOfUnit = 'noOfUnit',
  unitPrice = 'unitPrice',
}

export interface IAdvancedPriceSetting<T> extends IProductSetPriceSettings<T> {
  titleError?: boolean;

  setPriceError?: boolean;
  notesError?: boolean;
  currencyError?: boolean;
  items: T[];
  key?: string;
  open?: boolean;
}
export interface IAdvancedPriceSettingItem
  extends IProductSetPriceSettingsItems {
  unitPriceError?: boolean;
  noOfUnitError?: boolean;
  key?: string;
  marked?: boolean;
}
export interface IProductSet extends OringinalIProductSet {
  noOfUnitError?: boolean;
  unitPriceError?: boolean;
  marked?: boolean;
  uuid?: string;
}
